import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController,ModalController,IonRouterOutlet } from '@ionic/angular';
import { ChooseplanPage } from '../chooseplan/chooseplan.page';
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-plan',
  templateUrl: './plan.page.html',
  styleUrls: ['./plan.page.scss'],
})

export class PlanPage implements OnInit {

  data:any;
  myplan:any;
  activePlan:any;
  pid:any;
  text:any;

  constructor(private routerOutlet: IonRouterOutlet,public modalController: ModalController,public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

  this.data = JSON.parse(localStorage.getItem(Constant.planData));
  this.text = JSON.parse(localStorage.getItem(Constant.appText));

  }

  ngOnInit()
  {
  }

  selectPlan(plan)
  {
    this.pid        = plan.id;
    this.activePlan = plan;
  }

  ionViewDidEnter()
  {
    this.loadData();
  }

  async loadData()
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.myPlan().subscribe((response:any) => {

    this.myplan = response.data;

    loading.dismiss();

    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }

  async choosePlan() {

    if(!this.pid)
    {
      return this.presentToast(this.text.plan_error);
    }

    const modal = await this.modalController.create({
      component: ChooseplanPage,
      animated:true,
      mode:'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss:false,
      swipeToClose: true,
      presentingElement: this.routerOutlet.nativeEl,
      componentProps: {
        'plan': this.activePlan
      }

    });

   modal.onDidDismiss().then(data=>{


    })

    return await modal.present();
  }
}
